export const GET_CATEGORY = "GET_CATEGORY"
export const GET_CATEGORY_BY_ID = "GET_CATEGORY_BY_ID"
export const GET_CATEGORY_BY_ID_SUCCESS = "GET_CATEGORY_BY_ID_SUCCESS"
export const GET_CATEGORY_SUCCESS = "GET_CATEGORY_SUCCESS"
export const GET_CATEGORY_ERROR = "GET_CATEGORY_ERROR"

export const GET_CATEGORY_LIST = "GET_CATEGORY_LIST"
export const GET_CATEGORY_LIST_SUCCESS = "GET_CATEGORY_LIST_SUCCESS"
export const GET_CATEGORY_LIST_ERROR = "GET_CATEGORY_LIST_ERROR"
